export const fallbackLng = {
  en_GB: ["en"],
  en_US: ["en"],
  zh_CN: ["zh"],
  zh_TW: ["zh"],
  zh: ["zh"],
  default: ["en"],
};

export const supportedLngs = ["en", "zh", "dev", "en_GB", "zh_CN"];
